import React from "react";
import { Typography, Container, Stack, Paper } from '@mui/material';

class About extends React.Component {
  render() {
    return (
		<Container>
		<Paper elevation={2} sx={{p:2}}>
			<Stack spacing={2}>
				<Typography variant="h5" component="h1">
					Fractal Explorer
				</Typography>
				<Typography variant="subtitle">
					A browser based fractal explorer application for generating images of the Mandelbrot set and Julia sets.
				</Typography>
				<Typography variant="h6" component="h2">
					What is a Fractal?
				</Typography>
				<Typography>
					A fractal is a shape that exhibits self-similarity at different scales. The word was first used in 1975
					by Benoit Mandelbrot but some fractals were described much earlier, including the Koch snowflake and the
					Sierpinski triangle.
					
					Many shapes in nature approximate fractals, such as trees, mountain ranges and coastlines. One famous fractal
					known to mimic a natural shape is the Barnsley fern.
				</Typography>
				<Typography variant="h6" component="h2">
					What are Mandelbrot and Julia sets?
				</Typography>
				<Typography>
					The Mandelbrot set was first described by Robert Brooks and Peter Matelski in 1978 and named in honour of 
					Benoit Mandelbrot for his pioneering work on the theory of fractals. It is defined as the set of complex numbers 
					for which the iteration does not escape to infinity. Julia sets are another class of fractals defined similarly. 
					Julia sets are named after the French mathematician Gaston Julia whom alongside Pierre Fatou laid earlier 
					theoretical foundations for the study of such shapes with papers published in 1918 and 1917 respectively.
				</Typography>
			</Stack>
		</Paper>
		</Container>
    );
  }
}

export default About;